// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1AB9J","errorLogs":"EditorFooter_errorLogs__2epYm"};